'use client';
import React from 'react';
import TopPageAd from '../AdComponent/TopPageAd';

// Previously held a `selectedNews` state (never set — its setter was unused)
// and a next/dynamic import of VideoCard/Client for that path. That dead
// branch still produced a 551KB chunk in every build: VideoCard/Client
// imports constants/location_city.ts (800KB of city-code maps). The chunk
// was never fetched by any page, but it was dead code and build weight.
const NewsFeedController: React.FC<{
  initialNews: React.ReactNode;
  children: any[];
}> = ({ initialNews, children }) => {
  const handleNewsSelect = (event: any) => {
    const cardElement = event.target.closest('[data-id]');
    if (cardElement) {
      const newsId = cardElement.getAttribute('data-id');
      console.log('News selected:', newsId);
    }
  };

  return (
    <div className='flex flex-col lg:flex-row xl:flex-row lg:h-screen'>
      {initialNews ? (
        <div className='w-full lg:h-full lg:w-3/5 xl:w-3/5 relative lg:sticky lg:top-0 z-39'>
          <>
            <TopPageAd index={0} identifier={'website_728*90'} />
            {children[0]}
          </>
        </div>
      ) : null}
      <div
        className='w-full xl:h-full flex-grow-1 lg:h-full lg:overflow-y-auto no-scrollbar lg:w-2/5 xl:w-2/5'
        onClick={handleNewsSelect}
      >
        {children[1]}
      </div>
    </div>
  );
};

export default NewsFeedController;
